import { useState } from 'react'

const useHover = (): UseHoverFunctionReturnTypes => {
    const [open, setOpen] = useState<null | string>(null)
    const [timerId, setTimerId] = useState<NodeJS.Timeout | undefined>(undefined)

    const MouseEnterCallback = (id: string) => {
        clearTimeout(timerId)
        setOpen(id)
    }

    const MouseLeaveCallback = () => setTimerId(setTimeout(() => setOpen(null), 250))

    return { open, MouseEnterCallback, MouseLeaveCallback }
}

export default useHover
